"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAnyOf = void 0;
const parseSchema_1 = require("./parseSchema");
const parseAnyOf = (schema, refs) => {
  return schema.anyOf.length
    ? schema.anyOf.length === 1
      ? (0, parseSchema_1.parseSchema)(
          schema.anyOf[0],
          Object.assign(Object.assign({}, refs), {
            path: [...refs.path, "anyOf", 0],
          })
        )
      : `z.union([${schema.anyOf.map((schema, i) =>
          (0, parseSchema_1.parseSchema)(
            schema,
            Object.assign(Object.assign({}, refs), {
              path: [...refs.path, "anyOf", i],
            })
          )
        )}])`
    : `z.any()`;
};
exports.parseAnyOf = parseAnyOf;
